export default "__VITE_ASSET__CV2lRR88__"